define('helper-entity-isTaskInScore',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (entity) {
        return entity && entity.contentEntity && entity.contentEntity.inScore ? true : false;
    };
});
